import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const editLevel2Slice = createSlice({
  name: "editLevel2",
  initialState,
  reducers: {
    editLevel2Requested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    editLevel2RequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    editLevel2RequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  editLevel2Requested,
  editLevel2RequestFailed,
  editLevel2RequestSucceeded,
} = editLevel2Slice.actions;

export default editLevel2Slice.reducer;
